import {DrawingConfigStore} from "../../stores/drawingConfigStore";
import {DrawingConfigurationInterface} from "./interface/drawingConfigurationInterface";
import {MuntinInterface} from "./interface/muntinInterface";

export class DrawingDataService {

    private readonly MILLIMETER_MULTIPLIER = 1000;

    hasBottomPanel(): boolean
    {
        const config: DrawingConfigurationInterface = new DrawingConfigStore().get();
        if (config.sashes !== undefined) {
            config.sashes.forEach(mainSash => {
                if (mainSash.intSashes.length > 0) {
                    mainSash.intSashes.forEach(intSash => {
                        if (intSash.filling.type === 'pvc_panels') {
                            return true
                        }
                    })
                }
            });
        }
        return false;
    }

    getMullionsLengthInMeters()
    {
        const config: DrawingConfigurationInterface = new DrawingConfigStore().get();
        let mullionsLengthInMillimeters = 0;
        if (config.sashes !== undefined) {
            config.sashes.forEach(mainSash => {
                mainSash.intMullions.forEach(intMullion => {
                    mullionsLengthInMillimeters += intMullion.length;
                })

            });
        }
        return mullionsLengthInMillimeters / this.MILLIMETER_MULTIPLIER;
    }

    getMuntinsFieldsCount(): number
    {
        const config: DrawingConfigurationInterface = new DrawingConfigStore().get();

        let muntinFieldsCount = 0;
        let sashesCount = 0;

        if (config.sashes !== undefined) {
            config.sashes.forEach(mainSash => {
                if (mainSash.intSashes.length > 0) {
                    mainSash.intSashes.forEach(intSash => {
                        if (intSash.filling.type !== 'pvc_panels') {
                            let verticalMuntinsCount = 0;
                            let horizontalMuntinsCount = 0;
                            let diagonalMuntinsCount = 0;
                            sashesCount += 1;

                            intSash.muntins.forEach(muntin => {
                                if (this.getMuntinType(muntin) === 'horizontal') {
                                    horizontalMuntinsCount++;
                                }

                                if (this.getMuntinType(muntin) === 'vertical') {
                                    verticalMuntinsCount++;
                                }

                                if (this.getMuntinType(muntin) === 'diagonal') {
                                    diagonalMuntinsCount++;
                                }
                            });

                            if (diagonalMuntinsCount > 0) {
                                muntinFieldsCount += diagonalMuntinsCount * 2;
                            } else if ((verticalMuntinsCount + horizontalMuntinsCount) > 0) {
                                muntinFieldsCount += (verticalMuntinsCount + 1) * (horizontalMuntinsCount + 1);
                            }
                        }
                    })
                } else {
                    sashesCount += 1;
                    let verticalMuntinsCount = 0;
                    let horizontalMuntinsCount = 0;
                    let diagonalMuntinsCount = 0;
                    mainSash.muntins.forEach(muntin => {
                        if (this.getMuntinType(muntin) === 'horizontal') {
                            horizontalMuntinsCount++;
                        }

                        if (this.getMuntinType(muntin) === 'vertical') {
                            verticalMuntinsCount++;
                        }

                        if (this.getMuntinType(muntin) === 'diagonal') {
                            diagonalMuntinsCount++;
                        }

                    });
                    if (diagonalMuntinsCount > 0) {
                        muntinFieldsCount += diagonalMuntinsCount * 2;
                    } else if ((verticalMuntinsCount + horizontalMuntinsCount) > 0) {
                        muntinFieldsCount += (verticalMuntinsCount + 1) * (horizontalMuntinsCount + 1);
                    }
                }
            });
        }
        return muntinFieldsCount;
    }

    getSashesDimensions()
    {
        let sashesDimensions = {};
        const config: DrawingConfigurationInterface = new DrawingConfigStore().get();
        if (config.sashes !== undefined) {
            config.sashes.forEach(mainSash => {
                sashesDimensions[mainSash.id] = {
                    width: this.roundNumber(mainSash.width),
                    height: this.roundNumber(mainSash.height),
                    area: this.roundNumber(this.getArea(mainSash.width, mainSash.height)),
                    type: mainSash.type.type,
                };
            });
        }
        return sashesDimensions;
    }

    getShapeDimensions()
    {
        const config: DrawingConfigurationInterface = new DrawingConfigStore().get();
        return {
            width: this.roundNumber(config.width),
            height: this.roundNumber(config.height),
            area: this.roundNumber(this.getArea(config.width, config.height)),
        };
    }

    getBottomPanelSquareMeterArea()
    {
        const config: DrawingConfigurationInterface = new DrawingConfigStore().get();
        let bottomPanelArea = 0;
        if (config.sashes !== undefined) {
            config.sashes.forEach(mainSash => {
                if (mainSash.intSashes.length > 0) {
                    mainSash.intSashes.forEach(intSash => {
                        if (intSash.filling.type === 'pvc_panels') {
                            bottomPanelArea += this.getArea(intSash.width, intSash.height);
                        }
                    })
                }
            });
        }
        return this.roundNumber(bottomPanelArea);
    }

    getGlassSquareMeterArea()
    {
        const config: DrawingConfigurationInterface = new DrawingConfigStore().get();
        let glassArea = 0;

        if (config.sashes) {
            config.sashes.forEach(mainSash => {
                if (mainSash.intSashes.length > 0) {
                    mainSash.intSashes.forEach(intSash => {
                        if (intSash.filling.type !== 'pvc_panels') {
                            glassArea += this.getArea(intSash.width, intSash.height);
                        }
                    })
                } else {
                    glassArea += this.getArea(mainSash.width, mainSash.height);
                }
            });
        }

        return this.roundNumber(glassArea);
    }

    getMainSashCount()
    {
        return new DrawingConfigStore().get().sashes.length;
    }

    getShape()
    {
        return new DrawingConfigStore().get().shape;
    }


    private getMuntinType(muntin: MuntinInterface): 'vertical'|'horizontal'|'diagonal'
    {
        if (muntin.start.x === muntin.end.x) {
            return 'vertical';
        }

        if (muntin.start.y === muntin.end.y) {
            return 'horizontal';
        }

        if (
            muntin.start.x !== muntin.end.x &&
            muntin.start.y !== muntin.end.y
        ) {
            return 'diagonal';
        }
    }

    private getArea(widthInMillimeters: number, heightInMillimeters: number): number
    {
        return (widthInMillimeters / this.MILLIMETER_MULTIPLIER) * (heightInMillimeters / this.MILLIMETER_MULTIPLIER);
    }

    private roundNumber(value)
    {
        return Math.round((value + Number.EPSILON) * 100) / 100;
    }
}
